module.exports = __webpack_public_path__ + "img/1.b29324c4.svg";